import { useState } from 'react';

import { getAuthToken } from '../utils/cookieUtils';
const GRAPHQL_API_URL = process.env.REACT_APP_GRAPHQL_API || 'http://localhost:4000/api/graphql';

const ADVANCE_TRAILER_STATUS = `
  mutation AdvanceTrailerStatus($lineageUuid: String!, $targetStatusName: String!) {
    advanceTrailerStatus(lineageUuid: $lineageUuid, targetStatusName: $targetStatusName) {
      success
      updatedLineage {
        uuid
      }
      previousStatus
      newStatus
      shipmentDirection
      errors
    }
  }
`;

// Simple toast notification functions - these would typically come from a toast library
const showSuccessToast = (message: string) => {
  console.log('SUCCESS:', message);
  // In a real app, you'd use something like react-hot-toast or similar
};

const showErrorToast = (message: string) => {
  console.error('ERROR:', message);
  // In a real app, you'd use something like react-hot-toast or similar
};

export function useAdvanceTrailerStatus() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAdvanceStatus = async (lineageUuid: string, targetStatusName: string) => {
    setLoading(true);
    setError(null);

    try {
      // Get auth token from cookie
      const authToken = getAuthToken();

      const response = await fetch(GRAPHQL_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
          query: ADVANCE_TRAILER_STATUS,
          variables: { lineageUuid, targetStatusName }
        })
      });

      const result = await response.json();

      if (result.errors) {
        throw new Error(result.errors[0].message);
      }

      if (result.data?.advanceTrailerStatus?.success) {
        // Success notification
        const { previousStatus, newStatus } = result.data.advanceTrailerStatus;
        showSuccessToast(`Status updated from ${previousStatus} to ${newStatus}`);
        
        // Trigger a page refresh to update the dock data
        // In a more sophisticated app, you'd use a state management solution or refetch specific queries
        window.location.reload();
      } else {
        // Show errors
        const errors = result.data?.advanceTrailerStatus?.errors || ['Unknown error'];
        const errorMessage = Array.isArray(errors) ? errors.join(', ') : errors;
        showErrorToast(errorMessage);
        setError(errorMessage);
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to advance trailer status';
      showErrorToast(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return { handleAdvanceStatus, loading, error };
}